import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormControl, Validators } from "@angular/forms";

@Component({
	selector: "app-two-button-one-input",
	templateUrl: "./two-button-one-input.component.html",
	styleUrls: ["./two-button-one-input.component.scss"],
	encapsulation: ViewEncapsulation.None
})
export class TwoButtonOneInputComponent {
	content = {
		title: "",
		text: "",
		label: "",
		buttonLeft: "",
		buttonRight: ""
	};

	input: FormControl = new FormControl("", Validators.required);

	constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<TwoButtonOneInputComponent>) {
		this.content.title = data.title ? data.title : "";
		this.content.text = data.text ? data.text : "";
		this.content.label = data.label ? data.label : "";
		this.content.buttonLeft = data.buttonLeft ? data.buttonLeft : "Cancelar";
		this.content.buttonRight = data.buttonRight ? data.buttonRight : "Confirmar";
	}

	close() {
		this.dialogRef.close(null);
	}

	save() {
		this.dialogRef.close(this.input.value);
	}
}
